
import React, { useEffect, useRef, useState } from "react";
import FirstBanner from "../Components/FirstBanner";
import Header from "../Components/Header";
import POSSystem from "../Components/POSSystem";
import Services from "../Components/Services";
import PlayStoreIcon from '../assets/playStore.png'
import PosLogoMainIcon from '../assets/posLogoMainIcon.png'
import SignUpPageImg from '../assets/SignUpPage.png' 
import BussinessDetailPage from '../assets/bussinessDetailPage.png' 

const LandingPage = () => {

  const [mobileView, setMobileView]: any = useState<boolean>(
    window.innerWidth <= 768
);

useEffect(() => {
    function updateSize() {
        if (window.innerWidth <= 768)
            setMobileView(true);
        else
            setMobileView(false);
    }
    window.addEventListener("resize", updateSize);
}, [mobileView]);


  return (
   <div>
       <Header/>
        <FirstBanner/>
      <Services/>
         <POSSystem/>

      <div style={mobileView?{background:'#f6f6f6',padding:20}:{background:'#f6f6f6',paddingTop:'5vw',paddingBottom:'6.25vw'}}>
        <div style={mobileView?{width:'100%',display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column'}:{width:'80%',margin:'0 auto',display:'flex',justifyContent:'space-between',alignItems:'center', flexDirection:'row',height:'100%',paddingLeft:'6.25vw'}}>
      <div style={{display:'flex',justifyContent:'center',flexDirection:'column'}}>
         <h1 style={{fontSize:mobileView?26:'3.25vw',color:'#000',fontWeight:'bold',letterSpacing:2,textAlign:mobileView?'center':'left'}}>
         Creating a Sabka POS<br />account is incredibly<br />straight forward.
         </h1>
         <div>
           <div style={{display:'flex',justifyContent:'flex-start',alignItems:'flex-start',marginTop:mobileView?10:'1.25vw',gap:mobileView?10:'1.5625vw'}}>
             <div className="accountList">
                <div></div>
             </div>
             <div>
               <h2 style={{fontSize:mobileView?20:'2vw',margin:0,fontWeight:600,color:'#39C4FF'}}>
             Download The App
             </h2>
             <div style={{marginTop:8,lineHeight:1.5,color:'grey',fontWeight:500,fontSize:mobileView?14:'1.25vw'}}>
             Download the Sabka POS App from the Play Store now and {!mobileView &&<br />}unlock a world of convenience at your fingertips!
             </div>
             </div>
           </div>
           <div style={{display:'flex',justifyContent:'flex-start',alignItems:'flex-start',marginTop:mobileView?10:'1.25vw',gap:mobileView?10:'1.5625vw'}}>
             <div className="accountList">
                <div></div>
             </div>
             <div>
               <h2 style={{fontSize:mobileView?20:'2vw',margin:0,fontWeight:600,color:'#39C4FF'}}>
               Sign up
             </h2>
             <div style={{marginTop:8,lineHeight:1.5,color:'grey',fontWeight:500,fontSize:mobileView?14:'1.25vw'}}>
             Sign up using your User Name, Gmail or Password.
             </div>
             </div>
           </div>
           <div style={{display:'flex',justifyContent:'flex-start',alignItems:'flex-start',marginTop:mobileView?10:'1.25vw',gap:mobileView?10:'1.5625vw'}}>
             <div className="accountList">
                <div></div>
             </div>
             <div>
               <h2 style={{fontSize:mobileView?20:'2vw',margin:0,fontWeight:600,color:'#39C4FF'}}>
               Start Billing
             </h2>
             <div style={{marginTop:8,lineHeight:1.5,color:'grey',fontWeight:500,fontSize:mobileView?14:'1.25vw'}}>
             In the final step, simply enter your contact number, business {!mobileView &&<br />}name and begin billing.
             </div>
             </div>
           </div>
         </div>
       </div>
       <div style={mobileView?{marginTop:15}:{paddingRight:'3.125vw'}}>
         <img style={{height:mobileView?250:'31.25vw'}} src={SignUpPageImg} alt="" />
         <img style={{height:mobileView?245:'30.80vw'}} src={BussinessDetailPage} alt="" />
       </div>
       </div>
      </div>

      <div className="bottomBgOverlay" id="downLoad">
         <div style={mobileView?{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column-reverse',padding:20}:{width:'80%',margin:'0 auto',display:'flex',justifyContent:'space-between',flexDirection:'row',height:'100%',paddingLeft:'6.25vw',alignItems:'center'}}>
         <div style={mobileView?{width:'100%',display:'flex',justifyContent:'center',alignItems:'center'}:{width:'40%'}}>
           <div className="logoBgCircle">
         <img src={PosLogoMainIcon} style={{width:mobileView?120:'29.625vw'}} alt="" />
         </div>
       </div>
         <div style={{display:'flex',justifyContent:'center',flexDirection:'column',alignItems:'flex-end'}}>
         <h1 style={{fontSize:mobileView?26:'3.25vw',fontWeight:'bold',letterSpacing:2,color:'#434343',lineHeight:1.4,textAlign:mobileView?'center':'end',margin:0}}>
       Experience Seamless <br />Billing With Our App,<br />Download Now!
         </h1>
         <br /><br />
       <div style={{fontSize:mobileView?16:'1.25vw',fontWeight:'bold',color:'#575757'}}>
       Faster • Simpler • Safer • Get Started
       </div>
       {!mobileView ?
       <img src={PlayStoreIcon} style={{marginTop:'2.5vw',width:'13.125vw',borderRadius:8,cursor:'pointer'}} alt="" />
       :
       <div style={{width:'100%',display:'flex',justifyContent:'center',alignItems:'center',marginTop:20,marginBottom:20}}>
         <img src={PlayStoreIcon} style={{marginTop:'2.5vw',width:110,borderRadius:0,cursor:'pointer'}} alt="" />
       </div>
      }
       </div>
       </div>
       </div>
   </div>
  );
};

export default LandingPage;
